import { getBusinessObject } from 'bpmn-js/lib/util/ModelUtil';
import type { BpmnElement } from '../../types/properties-panel';

export type BpmnStepManProps<T> = keyof T extends `fism:${string}`
    ? { [P in keyof T]: T[P] }
    : { [P in keyof T as `fism:${string & P}`]: T[P] };

export const stepManProps = <T>(
    props: Partial<T>
): Partial<BpmnStepManProps<T>> =>
    Object.fromEntries(
        Object.entries(props).map(([key, value]) => [
            key.startsWith('fism:') ? key : 'fism:' + key,
            value,
        ])
    ) as any;

export const stepManPropValue = <
    T extends BpmnElement,
    P extends string & keyof T['businessObject'],
>(
    element: T,
    prop: P extends `fism:${infer K}` ? K : P
): Partial<T['businessObject']>[P] =>
    getBusinessObject(element).get('fism:' + prop);

export const stepManPropsValues = <
    T extends BpmnElement,
    P extends string & keyof T['businessObject'],
    K extends P extends `fism:${infer S}` ? S : P,
>(
    element: T,
    ...props: K[]
    // @ts-expect-error
): Partial<{ [E in K]: T['businessObject'][`fism:${string & E}`] }> => {
    const bo = getBusinessObject(element);
    return Object.fromEntries(
        props.map((prop) => [prop, bo.get('fism:' + prop)])
    ) as any;
};
